import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from '../pages/Home'
import About from '../pages/About'
import Services from '../pages/Services'
import Registration from '../pages/Registration'
import Layout from '../components/Layout'
import Login from '../pages/Login'
import UpdateProfile from '../pages/UpdateProfile'
import Team from '../pages/Team'
import Privacy from '../pages/Privacy'
import Refund from '../pages/Refund'
import Disclaimer from '../pages/Disclaimer'
import TermsCondition from '../pages/TermsCondition'

const Routing = ({ galleryRef, contactRef }) => {
    return (
        <>
            {/* <BrowserRouter> */}
            <Routes>
                <Route element={<Layout />}>
                    <Route
                        element={<Home contactRef={contactRef} galleryRef={galleryRef} />}
                        path="/"
                    />
                    <Route
                        element={<About contactRef={contactRef}
                            galleryRef={galleryRef} />}
                        path='about'
                    />
                    <Route
                        element={<Services contactRef={contactRef} galleryRef={galleryRef} />}
                        path='services'
                    />
                    <Route
                        element={<UpdateProfile/>}
                        path='profile'
                    />

                    <Route element={<Team />} path="Team" />

                    <Route element={<Privacy />} path="Privacy" />

                    <Route element={<Refund />} path="Refund" />

                    <Route element={<Disclaimer />} path="Disclaimer" />

                    <Route element={<TermsCondition />} path="TermsCondition" />
                </Route>

                <Route
                    element={<Registration />}
                    path='register'
                />
                <Route
                    element={<Login />}
                    path='login'
                />

            </Routes>
            {/* </BrowserRouter> */}
        </>
    )
}

export default Routing